import React, { useState, useEffect, useCallback, useRef } from "react";
import Skeleton from '@mui/material/Skeleton';
import "./profileCompletion.css";
import noProfilePictureImage from "./images/no-user.png";
import {styled } from '@mui/styles';
import cross from "./images/cross.svg"
import camera from "./images/camera.png";
import "date-fns";
// import "react-dropdown/style.css";
import {
  NotificationManager,
} from "react-notifications";
import { BlobServiceClient } from "@azure/storage-blob";
import { FilePicker } from "react-file-picker";
// import "react-circular-progressbar/dist/styles.css";
import Cropper from 'react-easy-crop';
import Slider from '@mui/material/Slider';
import getCroppedImg from './cropImage';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import 'react-phone-number-input/style.css'
import 'react-html5-camera-photo/build/css/index.css';
import Tooltip from '@mui/material/Tooltip';
import profilePictureUpdateResponse from "../../../apis/profile/profilePictureUpdate";
import ProfileById from '../../../apis/profile/profileById'
import "react-phone-number-input/style.css";
import user_register from "../../../components/basicInfoForm/images/avatar.png";

const styleSx = {
  buttonAlign: {
    display: 'flex',
    alignItems: 'center',
    padding: '24px 42px',
  },
  bodyForEditProfile: {
    marginTop: '70px',
  },
  changeProfileTitle: {
    padding: '16px 42px',
  },
  changeProfileBody: {
    // Currently empty, define styles here as needed
  },
  arrow: {
    color: "#1A8FFF",
  },
  tooltip: {
    backgroundColor: "#1A8FFF",
    padding: "4px 13px",
    fontFamily: "Segoe-Semibold",
    fontSize: "13px"

  },
};



const StyledDialogTitleRoot = styled(MuiDialogTitle)(({ theme }) => ({
  margin: 0,
  padding: '8px',
  position: 'relative',
}));

const DialogTitleForProfilePic = ({ children, onClose, ...other }) => (
  <StyledDialogTitleRoot disableTypography {...other}>
    <Typography variant="h6">{children}</Typography>
    {onClose && (
      <div className="crossFormodal cp" onClick={onClose}>
        <img className="closeicon_set" src={cross} alt="" />
      </div>
    )}
  </StyledDialogTitleRoot>
);

// DialogContent
const DialogContentForprofilepic = styled(MuiDialogContent)(({ theme }) => ({
  marginTop: 0,
}));

// DialogActions
const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  margin: 0,
  padding: '16px',
}));
// for tooltip

const BootstrapTooltip = (props) => (
  <Tooltip
    arrow
    {...props}
    slotProps={{
      tooltip: { sx: styleSx.tooltip },
      arrow: { sx: styleSx.arrow },
    }}
  />
);


const ProfileCompletion = ({ setLastUpdate, userId, mailData, setMailData,profileData}) => {
  const jsonConfig = require("../../../Config.json");
  // const [profileData, setProfileData] = useState({});
  const [userEmail, setUserEmail] = useState("");
  const [profilePicture, setProfilePicture] = useState(noProfilePictureImage);
  const [modalProfilePictureUrl, setModalProfilePictureUrl] = useState(null);
  const [profilePictureEditModal, setProfilePictureEditModal] = useState(false);
  const [loadingController, setLoadingController] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [rotation, setRotation] = useState(0)
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
  const [previousImageURL, setPreviousImageURL] = useState('')
  const [display, setdisplay] = useState(false);
  const [isEmailCopied, setisEmailCopied] = useState(false)
  const userCameraStreamRef = useRef(null);
  const [isDefaultProfile, setisDefaultProfile] = useState(false)

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }, [])
  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        modalProfilePictureUrl,
        croppedAreaPixels,
        rotation
      )
      var block = croppedImage.split(";");

      var contentType = block[0].split(":")[1];
      var realData = block[1].split(",")[1];
      await b64toBlob(realData, contentType,true);
      setdisplay(false);
    } catch (e) {
      console.error(e)
    }
  }, [croppedAreaPixels, rotation])

  // for delete profile img

  const removeImage = useCallback(async (defaultProfilePicture) => {
    let cropArea = {
      height: 250,
      width: 250,
      x: 0,
      y: 0
    }
    try {
      const croppedImage = await getCroppedImg(
        user_register,
        cropArea,
        0

      );
      var block = croppedImage.split(";");

      var contentType = block[0].split(":")[1];
      var realData = block[1].split(",")[1];
      await b64toBlob(realData, contentType, false, defaultProfilePicture);
      setdisplay(false);
      closeProfilePicModal();
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  const deleteCroppedImg = () => {
    const defaultProfilePicture = true;
    removeImage(defaultProfilePicture);
  }



  const getProfileData = () => {
    try {
      const user = profileData.user;
      setUserEmail(user.email)
    }
    catch (error) {
      console.log(error);
    }

    try {
      profileData?.profilePicUrl == null ? setPreviousImageURL('') : setPreviousImageURL(profileData?.profilePicUrl) 
      if (
        profileData?.profilePicUrl !== "" &&
        profileData?.profilePicUrl != null
      ) {
        setProfilePicture(profileData?.profilePicUrl);
      }
      if(userEmail)
      setLoadingController(true);
    } catch (error) {
    }
  };
  const getProfileDatas = async()=>{

    try {
      const profileResponse = await ProfileById(userId);
      var profileDataParsed = profileResponse.data.data[0];
     
      setLastUpdate(profileDataParsed.lastUpdated); 
      if (
        profileResponse.data?.data[0]?.profilePicUrl !== "" &&
        profileResponse.data?.data[0]?.profilePicUrl != null
      ) {
        setProfilePicture(profileResponse.data?.data[0]?.profilePicUrl);
      }
    } catch (error) {
      // setLoadingController(true);
    }
  }
  const b64toBlob = async (b64Data, contentType,status,defaultProfilePicture, sliceSize) => {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType }, { name: 'profile.png' });
    await uploadToBlobStorage(blob,status,defaultProfilePicture);
  }
  const b64toBlobForCamera = async (b64Data, contentType, sliceSize) => {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType }, { name: 'profile.png' });
    const url = URL.createObjectURL(blob)
    setModalProfilePictureUrl("");
		setTimeout(() => setModalProfilePictureUrl(url), 0);
  }

  const filePickerOnChange = async (file) => {
    const downloadedUrl = URL.createObjectURL(file);
    setModalProfilePictureUrl(downloadedUrl);
  };


  const uploadToBlobStorage = async (blob,status,defaultProfilePicture) => {
    const sas = jsonConfig.sasToken;
    const bsClient = new BlobServiceClient(
      `${jsonConfig.ctResourcesCdn + sas}`
    );
    const containerClient = bsClient.getContainerClient("profilepicture");
    let timeStamp = new Date().getTime();
    const profileFileName=defaultProfilePicture?"defaultProfile_":"profile_";
    const blobName =  userId + "/" + profileFileName+ timeStamp + ".png";
    const url = `${jsonConfig.ctResourcesCdn}/profilepicture/${blobName}`
    const blobClient = containerClient.getBlockBlobClient(blobName);
     await blobClient.uploadBrowserData(blob);
    var dt = new Date();
    var profileimagedata = {
      profilePicUrl: url,
      lastUpdated: dt,
      previousProfielPicUrl: previousImageURL
    };
    try {
      const payload = {
        userId: userId,
        profileimagedata: profileimagedata,
      }

      await profilePictureUpdateResponse(payload);
      if (status === true) {
        NotificationManager.success("Profile picture uploaded", "Success", 10000);
    }
    else {
        NotificationManager.success("Profile picture removed", "Success", 10000);
    }
      getProfileDatas();
      setProfilePictureEditModal(false);
    }
    catch (error) {
      console.error(error);
    }
  }



  const openProfilePictureModal = async () => {
    getProfileData();
    setModalProfilePictureUrl(profilePicture)
    !profileData.profilePicUrl?<>{setisDefaultProfile(true)}</>: profilePicture.includes("default")?setisDefaultProfile(true):setisDefaultProfile(false)
    setProfilePictureEditModal(true);
  };
  const closeProfilePicModal = async () => {
    setdisplay(false);
    if (userCameraStreamRef.current) {
      userCameraStreamRef.current.getTracks().forEach((track) => track.stop());
    }
    setProfilePictureEditModal(false)
  }

 
  // phone no validation chk api call

  // for camera
  const constraints = {
    audio: false,
    video: {
      width: 640, height: 420
    }
  };

  const opencameraModal = async () => {
    setdisplay(true)

    const video = document.getElementById('video');

    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      window.stream = stream;
      video.srcObject = stream;
      userCameraStreamRef.current = stream;
    } catch (e) {
    }

  }
  const captureImage = async () => {
    const video = document.getElementById("video");
		const canvas = document.getElementById("canvas");
		const context = canvas.getContext("2d");
		context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageUrl = canvas.toDataURL('image/jpeg');
    var block = imageUrl.split(";");

    var contentType = block[0].split(":")[1];
    var realData = block[1].split(",")[1];
    await b64toBlobForCamera(realData, contentType);
    setdisplay(false);
    if (userCameraStreamRef.current) {
			userCameraStreamRef.current.getTracks().forEach((track) => track.stop());
		}
  }
  const copyEmail = (e, useremail) => {
    setisEmailCopied(true)
    navigator.clipboard.writeText(useremail);
    setTimeout(
      changeCopyText
      , 3000
    )
  }
  const changeCopyText = () => {
    setisEmailCopied(false)
  }
  
  const getCustomizedFirstName = (fullName) => {
    const names = fullName.split(" ");
    let firstName = names[0];
  
    if (firstName.length > 15) {
      firstName = `${firstName.slice(0, 15)}...`;
    }
    return firstName;
  };

  useEffect(() => {
    getProfileData();
  }, [profileData]);

  return (
    <>
      {
        loadingController ?
          <>
            <div className="card_top profile_card pb_5 ">
              <div className="row">
                <div className="mt_22">
                  <div className="fle">
                    <div className="recruiter_profile_image_contain mt_10">
                      <img
                        src={profilePicture}
                        alt=""
                        className="powerProfileImage"
                      />
                      <img src={camera}
                        className="camera_icon_profile  cp"
                        onClick={openProfilePictureModal}
                        alt=""
                      />
                    </div>
                    <div>
                  
                  <p className="fs-bold fs-12 f-color resume_name">
                    {profileData.user ? getCustomizedFirstName(profileData.user.firstName) : ""} {profileData.user ? profileData.user.MiddleInitial : ""} {profileData.user ? profileData.user.lastName : ""}

                  </p>
                  <BootstrapTooltip title={isEmailCopied ? "Copied" : "Click to copy Email"}>
                    <p className="fs-regular fs-14 f-color br-word email_hidde ml_12" onClick={(e) => copyEmail(e, userEmail)} >{userEmail ? userEmail : ""}</p>
                  </BootstrapTooltip>
                  </div>
                  </div>
                </div>
                <div >
                </div>
              </div>
            </div>             
            <Dialog
              open={profilePictureEditModal}
              onClose={closeProfilePicModal}
              aria-labelledby="customized-dialog-title"
              maxWidth="sm"
              fullWidth={true}
              className='record-video-intro-responsive'
            >
              <DialogTitleForProfilePic className="responsive-profilepic_title" sx={styleSx.changeProfileTitle} onClose={closeProfilePicModal}>Change Profile Picture</DialogTitleForProfilePic>

              <DialogContentForprofilepic className="responsive-profilepic_body" sx={styleSx.changeProfileBody}>
                {display ? null :
                  <div className="text-center">
                    <div className="crop-container" id="circle_ProfilePic">
                      <Cropper
                        image={modalProfilePictureUrl}
                        crop={crop}
                        rotation={rotation}
                        zoom={zoom}
                        // aspect={4 / 3}
                        aspect={1 / 1}
                        onCropChange={setCrop}
                        onRotationChange={setRotation}
                        onCropComplete={onCropComplete}
                        onZoomChange={setZoom}
                      />
                    </div>
                    <div className="controls">
                      <div className="w-100">
                        <p className="fs-semi-bold fs-15 mt_19 f-color">Zoom</p>
                        <Slider
                          value={zoom}
                          min={1}
                          max={3}
                          step={0.1}
                          aria-labelledby="Zoom"
                          onChange={(e, zoom) =>
                            setZoom(zoom)}
                        />
                      </div>
                      <div className="w-100">
                        <p className="fs-semi-bold fs-15 mt_19 f-color">Rotation</p>
                        <Slider
                          value={rotation}
                          min={0}
                          max={360}
                          step={1}
                          aria-labelledby="Rotation"
                          onChange={(e, rotation) =>
                            setRotation(rotation)}
                        />
                      </div>
                    </div>
                    <div className="profilecamera_upload">
                      <FilePicker
                        extensions={['jpg', 'jpeg', 'png']}
                        onChange={filePickerOnChange}
                        onError={errMsg => {
                          NotificationManager.error(errMsg, 'Error',10000);
                        }}
                      >
                        <button type="button" className="btn change_profile_btn cp ">Upload Picture</button>
                      </FilePicker>
                      <span><button type="button" className="btn change_profile_btn ml_5 cp " onClick={opencameraModal}>Use My Camera</button></span>
                    </div>
                  </div>
                }
                <div className="camera_section">
                  <video id="video" playsInline autoPlay style={display ? { display: "block", width: "100%" } : { display: "none" }}></video>
                  <button id="snap" className="btn change_profile_btn cp " onClick={captureImage} style={display ? { marginTop: "26px", marginBottom: "26px" } : { display: "none" }}>Capture</button>
                  <canvas id="canvas" width="640" height="480" style={{ display: "none" }}></canvas>
                </div>

              </DialogContentForprofilepic>
              {display ? null :
                <>
                  <div className="divider_adjust">
                    <hr className="new3 mt_20 mb_0" />
                  </div>
                  <DialogActions className="responsive-dialog" sx={styleSx.buttonAlign}>
                    <button type="button" className="btn-big btn-skill cp " onClick={closeProfilePicModal}>Cancel</button>
                    {isDefaultProfile ?
                                <>
                                </> :
                                <>
                            <button
                                type="button"
                                className="btn-big btn-skill ml_5 cp "
                                onClick={deleteCroppedImg}
                            >Remove
                            </button>
                            </>}
                    <button type="button" className="btn-big btn-green ml_5 cp "
                      onClick={showCroppedImage}
                    >Save</button>
                  </DialogActions>
                </>
              }
            </Dialog>
          </>
          :
          <>

<div className="card_top profile_card pb_5 " style={{width:'30vh'}} >
              <div className="row">
                <div className="mt_22">
                  <div className="fle">
                    <div className="recruiter_profile_image_contain mt-10">

                    <Skeleton variant="circle" width={40} height={40} animation="wave" />
                      
                    </div>
                    <div>               
                  <p className="fs-bold fs-12 f-color resume_name" style={{width:'20vh'}}>
                    <Skeleton variant="text" animation="wave" />
                  </p>
                  <p className="fs-bold fs-12 f-color">
                    <Skeleton variant="text" animation="wave" />
                  </p>
               
                  </div>
                  </div>
                </div>
                <div >
                </div>
              </div>
            </div>
          </>
      }
    </>

  );
};
export default ProfileCompletion

